import {
    requestSubmit,
    sendRequest
} from "../api"
import {
    ADD_IN_LIST,
    RESET_STATE,
    SET_DETAIL,
    SET_LIST
} from "../constant-types"

import {
    getField,
    updateField
} from 'vuex-map-fields'

const getDefaultState = () => {
    return {
        list: null,
        search_params: getDefaultSearchParamsState(),
        detail: null
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text: '',
        loading: false,
        filter_sort: [{
            column: 'purchases.id',
            sort: 'desc',
            icon: ['fas', 'angle-down']
        }],
        filter_page: 1,
        filter_limit: 10
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_IN_LIST](state, createdPurchase) {
            // only add if exist
            if (state.list) {
                state.list.data.unshift(createdPurchase)
            }
        },
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [SET_DETAIL](state, purchase) {
            state.detail = purchase
        },
        [SET_LIST](state, payload) {
            state.list = payload
        },
        updateField

    },
    // can async
    actions: {
        newTransaction({
            commit,
            dispatch
        }) {
            dispatch('resetForm')
            dispatch('userCash/loadList', null, {
                root: true
            })
        },
        resetForm({commit}) {
            commit('purchaseForm/RESET_FORM', null, { root: true})
            commit('pictureForm/RESET_FORM', null, { root: true})
        },
        loadDetail({
            commit
        }, purchaseId) {
            return sendRequest(`purchase/${purchaseId}`, {}, 'get', (purchase) => commit(SET_DETAIL, purchase))
        },
        loadList({
            commit,
            state
        }, payload = {
            resetPage: false
        }) {
            if (payload.resetPage) {
                commit('updateField', {
                    path: 'search_params.filter_page',
                    value: 1
                })
            }
            return getSearch({
                    words: _.split(state.search_params.filter_search_text, ' '),
                    fields: ['purchases.id', 'supplier.name', 'invoice_code']
                },
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                [],
                [],
                'purchase',
                (response) => commit(SET_LIST, response),
                () => {},
                () => {}
            )
        },
        requestSavePurchase({
            commit,
            rootState
        }) {
            let formData = {
                ...rootState.purchaseForm,
                pictures: rootState.pictureForm.pictures,
                new_pictures: rootState.pictureForm.new_pictures.map(np => ({ caption: np.caption, file: np.file }))
            }
            return requestSubmit('purchase', formData, commit, 'post', 
                (createdPurchase) => {
                    commit(SET_DETAIL, createdPurchase)
                    commit(ADD_IN_LIST, createdPurchase)
                }
            )
        },
        requestCancelPurchase({commit, state}, purchaseId) {
            return requestSubmit(`purchase/cancel/${purchaseId}`, {}, commit, 'post',
                (cancelledPurchase) => {
                    // refresh all posibility selector
                    app.$events.fire('refresh-selector')
                }
            )
        },
    },
    // call variable with custom display
    getters: {
        getField
    }
})
